import Wagner from '../assets/clients/Wagner.png';
import SDIS from '../assets/clients/SDIS.png';
import BCFD from '../assets/clients/BCFD.png';
import "../styles/ClientItem.css";

function getImageUrl(client){
    switch(client){
        case "Wagner":
            return Wagner;
        case "SDIS":
            return SDIS;
        case "BCFD":
            return BCFD;
        default:
            return "";
    }
}


function ClientItem(props){
    console.log(props);
    const client = props.client.client;
    const client_url = props.client.client_url;

    return(
        <a href={client_url} target="_blank" rel="noreferrer">
            <img src={getImageUrl(client)} alt={client} className="d-client-item"/>
        </a>
        
    )
}


export default ClientItem;